/**
 * DataGrail consent IDs for third-party tracking scripts.
 * These IDs link scripts to consent categories in the DataGrail dashboard.
 *
 * Category mapping:
 * - essential: Always-on, required functionality
 * - functional: Analytics and performance monitoring
 * - performance: Performance metrics
 * - marketing: Advertising and marketing trackers
 *
 * To update these IDs:
 * 1. Log into DataGrail dashboard
 * 2. Navigate to Consent Management > Scripts
 * 3. Find the script and copy its consent ID
 * 4. Update the corresponding constant below
 */
export const DATAGRAIL_CONSENT_IDS = Object.freeze({
  /**
   * Bing UET (Universal Event Tracking) for ad campaigns
   * Category: Marketing
   */
  BING_ADS: '7Lylth90ZOjJmYeAaw6Ufl',

  /**
   * Google Floodlight conversion tracking (DoubleClick)
   * Category: Marketing
   */
  FLOODLIGHT_GOOGLE_ANALYTICS: '6jxwWOFxc79CCdmTpRKwj9',

  /**
   * Index Exchange ad wrapper tracking script
   * Category: Marketing
   */
  AD_WRAPPER_INDEX: '1GgasTGbCFBFuMMzVqFoAD',

  /**
   * Google Ad Services conversion tracking
   * Category: Marketing
   */
  GOOGLE_AD_SERVICES: '7fhug8sc32a3eRySEh60JU',

  /**
   * Comscore audience measurement
   * Used for both Performance and Functional categories
   */
  COMSCORE: '7D7U46annCfEZFbHjhl2tu',
} as const);

/**
 * Type helper for TypeScript autocompletion
 * Use this type when you need to accept any valid DataGrail consent ID
 */
export type DataGrailConsentId = (typeof DATAGRAIL_CONSENT_IDS)[keyof typeof DATAGRAIL_CONSENT_IDS];
